import MuiDialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";

import IconButton from "features/components/IconButton";
import CloseIcon from "features/ui/Icons/CloseIcon";

import { DialogProps } from "./types";

const Dialog = ({
  testId,
  title,
  children,
  showCloseIcon = false,
  onClose,
  actions,
  contentSx,
  ...props
}: DialogProps) => {
  const closeButton = (
    <IconButton
      onClick={() => onClose?.({}, "closeButtonClick")}
      data-testid="dialog-close-button"
      className="!ml-auto"
      size="xs"
    >
      <CloseIcon />
    </IconButton>
  );

  return (
    <MuiDialog data-testid={testId} {...props} onClose={onClose}>
      {title && (
        <DialogTitle>
          <Stack direction="row" className="items-center">
            {title}
            {showCloseIcon && closeButton}
          </Stack>
        </DialogTitle>
      )}
      <DialogContent sx={contentSx}>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialog;
